import {
  GET_FAQ_PROFILE,
  GET_FAQ_PROFILE_FAIL,
  GET_FAQ_PROFILE_SUCCESS,
  GET_FAQS,
  GET_FAQS_FAIL,
  GET_FAQS_SUCCESS,
  ADD_NEW_FAQ,
  ADD_FAQ_SUCCESS,
  ADD_FAQ_FAIL,
  UPDATE_FAQ,
  UPDATE_FAQ_SUCCESS,
  UPDATE_FAQ_FAIL,
  DELETE_FAQ,
  DELETE_FAQ_SUCCESS,
  DELETE_FAQ_FAIL,
} from "./actionTypes"

export const getFaqs = ({is_active,offset='',page_size=''}) => ({
  type: GET_FAQS,
  payload:{is_active,offset,page_size}
})

export const getFaqsSuccess = faqs => ({
  type: GET_FAQS_SUCCESS,
  payload: faqs,
})

export const getFaqsFail = error => ({
  type: GET_FAQS_FAIL,
  payload: error,
})

export const addNewFaq = (user,history) => ({
  type: ADD_NEW_FAQ,
  payload: {user,history},
})

export const addFaqSuccess = user => ({
  type: ADD_FAQ_SUCCESS,
  payload: user,
})  

export const addFaqFail = error => ({
  type: ADD_FAQ_FAIL,
  payload: error,
})

export const updateFaq = (faq,history) => ({
  type: UPDATE_FAQ,
  payload: {faq,history},
})

export const updateFaqSuccess = user => ({
  type: UPDATE_FAQ_SUCCESS,
  payload: user,
})

export const updateFaqFail = error => ({
  type: UPDATE_FAQ_FAIL,
  payload: error,
})

export const deleteFaq = user => ({
  type: DELETE_FAQ,
  payload: user,
})

export const deleteFaqSuccess = user => ({
  type: DELETE_FAQ_SUCCESS,
  payload: user,
})

export const deleteFaqFail = error => ({
  type: DELETE_FAQ_FAIL,
  payload: error,
})

export const getFaqProfile = (payload) => ({
  type: GET_FAQ_PROFILE,
  payload:payload
})

export const getFaqProfileSuccess = userProfile => ({
  type: GET_FAQ_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getFaqProfileFail = error => ({
  type: GET_FAQ_PROFILE_FAIL,
  payload: error,
})
